export default __webpack_public_path__ + "static/media/hanu-heat-treaters.449a30fe.webp";